<template>
  <div id="secondInterview">
    <div class="detail_container">
      <div class="detail_recruit_info">
        <el-form ref="form" :model="form" label-width="90px" label-position="left">
          <el-form-item label="候 选 人：">
            <div class="recruit_type">{{ list.name }}</div>
          </el-form-item>
          <el-form-item label="面试岗位：">
            <div class="recruit_type">{{ list.department }}</div>
          </el-form-item>
          <el-form-item label="复 试 官：">
            <!-- <el-input v-model="form.interviewer" placeholder="请输入工号或姓名"></el-input> -->
            <el-select
              v-model="form.interviewer"
              multiple
              filterable
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.empNo"
                :label="item.empName"
                :value="item.empNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="复试时间：">
            <el-input
              placeholder="请选择复试时间"
              suffix-icon="el-icon-date"
              v-model="form.interviewTime"
              clearable
              @focus="inputFocus">
            </el-input>
            <van-popup v-model="showMonth" round position="bottom">
              <van-datetime-picker
                v-model="nowMonth"
                type="datetime"
                :min-date="minDate"
                :formatter="formatter"
                @confirm="comfirmDateTime"
                @cancel="showMonth = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="复试地点：">
            <el-input v-model="form.interviewAddr" placeholder="请输入面试地点"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_container">
        <el-button @click="getback">取消</el-button>
        <el-button type="primary" @click="confirmClick">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apis/inside'
import moment from "moment";
export default {
  data() {
    return {
      salaryInfo: {},
      list: JSON.parse(this.$route.query.list),
      showMonth: false,
      nowMonth: new Date(),
      options: [],
      form: {
        interviewer: '',
        interviewTime: '',
        interviewAddr: '',
      },
      minDate: new Date('2020/1/1'),
    }
  },
  mounted() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
    this.selectEmployee()
  },
  methods: {
    //格式化时间
    formatter(type, val) {
      if (type == 'year') {
        return `${val}年`
      } else if (type == 'month') {
        return `${val}月`
      } else if (type == 'day') {
        return `${val}日`
      } else if (type == 'hour') {
        return `${val}时`
      } else if (type == 'minute') {
        return `${val}分`
      } else {
        return val
      }
    },
    //获取面试官
    selectEmployee() {
      api.selectEmployee({
        searchName: this.list.operateNo,
      }).then((res) => {
        if (res.code == 200) {
          this.options = res.data
        }
      })
    },
    //返回
    getback() {
      this.$router.back()
    },
    // 确定面试
    confirmClick() {
      api.secondInterview({
        recordUuid: this.list.recordUuid,
        interviewAddr: this.form.interviewAddr,
        operatorNo: this.salaryInfo.empNo,
        hrEmpNo: this.form.interviewer.join(),
        interviewTime: this.form.interviewTime,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.$router.replace({
            path: '/HR/deliveryRecord',
          })
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          });
        }
      })
    },
    //显示时间
    inputFocus() {
      this.showMonth = true
    },
    //选择时间
    comfirmDateTime(val) {
      this.form.interviewTime = moment(val).format("YYYY-MM-DD HH:mm");
      this.showMonth = false
    },
  }
}
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #secondInterview {
    width: 100%;
  }
  .van-popup {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #secondInterview {
    width: 276px * $zoom;
  }
  .van-popup {
    left: 50%;
    transform: translate(-50%);
    width: 276px * $zoom;
  }
}
#secondInterview {
  font-size: 16px * $zoom;
  position: relative;
  .detail_container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 136px;
    background: #F7F9FA;
    .detail_recruit_info {
      padding: 32px;
      background: #fff;
      ::v-deep .el-form {
        .el-form-item {
          &:last-child {
            margin: 0;
          }
          .el-form-item__label {
            padding: 0;
            font-size: 30px;
            line-height: 64px;
            color: #666666;
          }
          .el-form-item__content {
            line-height: 64px;
            .recruit_type {
              font-size: 30px;
              color: #282B32;
            }
            .el-select {
              width: 100%;
              .el-input__suffix {
                top: -5px;
              }
            }
            .el-input {
              .el-input__inner {
                height: 64px;
                font-size: 30px;
                background: #FFFFFF;
                border-radius: 4px;
                border: 1rpx solid #C1C1C1;
                &::placeholder {
                  font-size: 30px;
                  color: #B5B5B5;
                }
              }
            }
          }
        }
      }
    }
    .btn_container {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 96px;
      background: #eee;
      .el-button {
        width: 35%;
        height: 100%;
        border: none;
        font-size: 30px;
        color: #282B32;
        border-radius: 0;
      }
      .el-button--primary {
        width: 65%;
        margin: 0;
        background: #4EA27C;
        color: #FFFFFF;
      }
    }
  }
}

</style>